import React from 'react';
import { Link } from 'react-router-dom';
import blogPosts from '../data/blogPosts';
import photos from '../data/photos';
import BlogListItem from '../components/BlogListItem';
import PhotoGrid from '../components/PhotoGrid';
import './Blog.css';

export default function Blog() {
  return (
    <main className="blog-container">
      <nav className="blog-nav">
        <Link to="/" className="back-link">← Home</Link>
        <a href="#photos" className="back-link">Photos ↓</a>
      </nav>
      <h1 className="blog-heading">Blog</h1>
      <p className="blog-intro">Check out what I've been up to here...</p>
      <ul className="blog-list">
        {blogPosts.map((post) => (
          <BlogListItem key={post.id} post={post} />
        ))}
      </ul>

      <section id="photos" className="photos-section">
        <h2 className="photos-heading">Photos</h2>
        <PhotoGrid photos={photos} />
      </section>
    </main>
  );
}
